import { useState } from 'react';

function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What foods improve your mood?',
      answer: 'Foods like warm pasta, chocolate, soup, and comfort meals can feel emotionally satisfying and may help improve mood for some people.'
    },
    {
      question: 'Why do people crave comfort food when sad?',
      answer: 'Comfort foods are often linked to warmth, familiarity, and emotional memories, which can make people feel better during difficult moments.'
    },
    {
      question: 'Can food help with stress?',
      answer: 'Some foods and drinks, such as tea, dark chocolate, yogurt, or simple comfort snacks, may help people feel calmer or more emotionally balanced.'
    }
  ];

  return (
    <section className="py-10">
      <h2 className="text-2xl font-semibold text-gray-900 mb-6 text-center">
        Frequently Asked Questions
      </h2>
      <div className="space-y-3 max-w-3xl mx-auto">
        {faqs.map((faq, index) => (
          <div key={index} className="bg-white rounded-xl shadow-sm border">
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full p-5 text-left flex justify-between items-center"
            >
              <span className="font-medium text-gray-900">{faq.question}</span>
              <span className="text-gray-400 text-lg">
                {openIndex === index ? '−' : '+'}
              </span>
            </button>
            {openIndex === index && (
              <div className="px-5 pb-5 text-gray-600 text-sm leading-relaxed">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQSection;
